import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="pt-32 pb-20 px-8">
        <div className="max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="mb-16">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-2 h-2 bg-[#1a2332] rotate-45"></div>
              <span className="text-sm font-medium text-[#1a2332] uppercase tracking-wider">Privacy Policy</span>
            </div>
            <h1 className="text-5xl font-bold text-[#2d3748] mb-6">プライバシーポリシー</h1>
            <p className="text-[#4a5568] leading-relaxed">
              Trim-Page（以下「当サービス」といいます）は、お客様の個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます）を遵守すると共に、以下のプライバシーポリシー（以下「本ポリシー」といいます）に従い、適切な取扱い及び保護に努めます。
            </p>
            <p className="text-sm text-[#4a5568] mt-4">最終更新日：2025年1月1日</p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                1. 個人情報の定義
              </h2>
              <p className="text-[#4a5568] leading-relaxed">
                本ポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義された個人情報、すなわち、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、メールアドレス、その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます）を指します。
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                2. 個人情報の取得
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                当サービスは、以下の方法により個人情報を取得します。
              </p>
              <ul className="space-y-3">
                {[
                  'お問い合わせフォームからのご入力',
                  'メールでのお問い合わせ',
                  'サービスご契約時の情報提供',
                  'お電話でのお問い合わせ'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-[#1a2332] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568] leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                3. 取得する個人情報の項目
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                当サービスが取得する個人情報は以下の通りです。
              </p>
              <ul className="space-y-3">
                {[
                  '氏名（法人名・屋号を含む）',
                  'メールアドレス',
                  '電話番号',
                  '住所',
                  '事業内容・業種',
                  'ウェブサイトURL',
                  'お問い合わせ内容',
                  'その他、お客様が任意で提供する情報'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-[#1a2332] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568] leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                4. 個人情報の利用目的
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                当サービスは、取得した個人情報を以下の目的で利用します。
              </p>
              <ul className="space-y-3">
                {[
                  'お問い合わせへの対応',
                  'サービスのご提供・契約の履行',
                  'お見積もりの作成・提示',
                  'サービスに関するご案内・ご連絡',
                  '納品物の送付・確認',
                  'サポート対応',
                  'ご請求・お支払いに関する連絡',
                  'サービス改善のための分析',
                  '新サービス・キャンペーンのご案内（お客様が希望された場合のみ）',
                  '上記に付随する業務'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-[#1a2332] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568] leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                5. 個人情報の第三者提供
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                当サービスは、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
              </p>
              <ul className="space-y-3">
                {[
                  '法令に基づく場合',
                  '人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合',
                  '公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合',
                  '国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合',
                  'お客様が事前に同意した場合'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-[#1a2332] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568] leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                6. 外部サービスの利用
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                当サービスは、サービス提供のために以下の外部サービスを利用する場合があります。これらのサービスにおける個人情報の取扱いについては、各サービスのプライバシーポリシーをご確認ください。
              </p>
              <div className="space-y-6">
                <div className="p-6 bg-[#f5f3f0] rounded-lg">
                  <h3 className="text-lg font-bold text-[#2d3748] mb-2">Cloudflare Pages</h3>
                  <p className="text-sm text-[#4a5568] leading-relaxed mb-2">
                    ウェブサイトのホスティング・配信に利用します。
                  </p>
                  <a
                    href="https://www.cloudflare.com/privacypolicy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-[#1a2332] underline hover:text-[#4a5568] transition-colors"
                  >
                    Cloudflare プライバシーポリシー
                  </a>
                </div>

                <div className="p-6 bg-[#f5f3f0] rounded-lg">
                  <h3 className="text-lg font-bold text-[#2d3748] mb-2">microCMS</h3>
                  <p className="text-sm text-[#4a5568] leading-relaxed mb-2">
                    コンテンツ管理システムとして利用する場合があります。
                  </p>
                  <a
                    href="https://microcms.io/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-[#1a2332] underline hover:text-[#4a5568] transition-colors"
                  >
                    microCMS プライバシーポリシー
                  </a>
                </div>

                <div className="p-6 bg-[#f5f3f0] rounded-lg">
                  <h3 className="text-lg font-bold text-[#2d3748] mb-2">Google reCAPTCHA</h3>
                  <p className="text-sm text-[#4a5568] leading-relaxed mb-2">
                    フォームのスパム対策として利用する場合があります。
                  </p>
                  <a
                    href="https://policies.google.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-[#1a2332] underline hover:text-[#4a5568] transition-colors"
                  >
                    Google プライバシーポリシー
                  </a>
                </div>

                <div className="p-6 bg-[#f5f3f0] rounded-lg">
                  <h3 className="text-lg font-bold text-[#2d3748] mb-2">SSGForm</h3>
                  <p className="text-sm text-[#4a5568] leading-relaxed mb-2">
                    お問い合わせフォームの送信処理に利用する場合があります。
                  </p>
                  <a
                    href="https://ssgform.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-[#1a2332] underline hover:text-[#4a5568] transition-colors"
                  >
                    SSGForm プライバシーポリシー
                  </a>
                </div>
              </div>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                7. Cookieおよびアクセス解析ツール
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                当サービスは、サービスの利便性向上および品質改善のため、Cookieおよびアクセス解析ツールを使用する場合があります。Cookieとは、ウェブサイトがお客様のコンピュータに送信する小さなテキストファイルで、お客様のブラウザに保存されます。
              </p>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                お客様は、ブラウザの設定によりCookieの受け取りを拒否することができますが、その場合、サービスの一部機能が正常に動作しない可能性があります。
              </p>
              <p className="text-[#4a5568] leading-relaxed">
                当サービスでは、Google Analyticsなどのアクセス解析ツールを使用する場合があります。これらのツールは、Cookieを使用してお客様の訪問情報を収集しますが、個人を特定する情報は含まれません。
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                8. 個人情報の安全管理措置
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                当サービスは、個人情報の漏えい、滅失又は毀損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。
              </p>
              <ul className="space-y-3">
                {[
                  '個人情報へのアクセス制限',
                  '個人情報を取り扱う機器・システムの管理',
                  '不正アクセス対策',
                  '個人情報の持ち出し制限',
                  '個人情報の削除・廃棄の適切な実施'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-[#1a2332] rounded-full flex-shrink-0 mt-2"></div>
                    <span className="text-[#4a5568] leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            {/* Section 9 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                9. 個人情報の開示・訂正・削除
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                お客様は、当サービスが保有する自己の個人情報について、開示、訂正、追加、削除、利用停止、消去および第三者提供の停止（以下「開示等」といいます）を請求することができます。
              </p>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                開示等のご請求は、以下のお問い合わせ窓口までご連絡ください。ご本人確認の上、合理的な期間内に対応いたします。
              </p>
              <div className="p-6 bg-[#f5f3f0] rounded-lg">
                <p className="text-sm text-[#4a5568] mb-2">
                  <strong className="text-[#2d3748]">お問い合わせ窓口：</strong>
                </p>
                <p className="text-sm text-[#4a5568]">
                  メールアドレス：<a href="mailto:info@trim-page.com" className="text-[#1a2332] underline hover:text-[#4a5568] transition-colors">info@trim-page.com</a>
                </p>
              </div>
            </section>

            {/* Section 10 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                10. 個人情報の保存期間
              </h2>
              <p className="text-[#4a5568] leading-relaxed">
                当サービスは、個人情報を利用目的の達成に必要な期間に限り保存します。利用目的を達成した後は、法令に基づく保存義務がある場合を除き、遅滞なく削除または匿名化します。
              </p>
            </section>

            {/* Section 11 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                11. お問い合わせ窓口
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                本ポリシーに関するお問い合わせは、以下の窓口までお願いいたします。
              </p>
              <div className="p-6 bg-[#f5f3f0] rounded-lg space-y-3">
                <div>
                  <p className="text-sm text-[#4a5568] mb-1">
                    <strong className="text-[#2d3748]">サービス名：</strong>
                  </p>
                  <p className="text-sm text-[#4a5568]">Trim-Page</p>
                </div>
                <div>
                  <p className="text-sm text-[#4a5568] mb-1">
                    <strong className="text-[#2d3748]">メールアドレス：</strong>
                  </p>
                  <p className="text-sm text-[#4a5568]">
                    <a href="mailto:info@trim-page.com" className="text-[#1a2332] underline hover:text-[#4a5568] transition-colors">info@trim-page.com</a>
                  </p>
                </div>
                <div>
                  <p className="text-sm text-[#4a5568] mb-1">
                    <strong className="text-[#2d3748]">受付時間：</strong>
                  </p>
                  <p className="text-sm text-[#4a5568]">平日 10:00〜18:00（土日祝日を除く）</p>
                </div>
              </div>
            </section>

            {/* Section 12 */}
            <section>
              <h2 className="text-2xl font-bold text-[#2d3748] mb-6 pb-3 border-b-2 border-[#f5f3f0]">
                12. プライバシーポリシーの変更
              </h2>
              <p className="text-[#4a5568] leading-relaxed mb-4">
                当サービスは、法令の変更、サービス内容の変更、その他必要に応じて、本ポリシーを変更することがあります。変更後のプライバシーポリシーは、本ページに掲載した時点から効力を生じるものとします。
              </p>
              <p className="text-[#4a5568] leading-relaxed">
                重要な変更がある場合は、ウェブサイト上で事前にお知らせいたします。
              </p>
            </section>
          </div>

          {/* Back to Home */}
          <div className="mt-16 pt-8 border-t border-[#e2e8f0] text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#1a2332] font-medium hover:text-[#4a5568] transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              <span>トップページへ戻る</span>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#1a2332] text-white py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* Left Column */}
            <div className="md:col-span-1">
              <div className="flex items-center gap-3 mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/4944a4ba-c62a-4964-bf85-4ed6714cc305.png" 
                  alt="Trim-Page Logo" 
                  className="w-10 h-10 object-contain"
                />
                <h3 className="text-3xl font-bold">Trim-Page</h3>
              </div>
              <p className="text-white/80 leading-relaxed mb-6">
                小規模店舗・個人事業主のための、月額費用のない静的サイト制作サービス
              </p>
              <div className="flex gap-4">
                {['ri-twitter-x-line', 'ri-facebook-circle-line', 'ri-instagram-line', 'ri-linkedin-box-line'].map((icon, index) => (
                  <a
                    key={index}
                    href="#"
                    className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white/10 transition-colors cursor-pointer"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Middle Column */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Contact</h4>
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-white/60 mb-1">メールアドレス</p>
                  <a href="mailto:info@trim-page.com" className="text-white hover:text-white/80 transition-colors">
                    info@trim-page.com
                  </a>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Information</h4>
              <div className="space-y-4">
                <Link to="/about-operator" className="block text-white hover:text-white/80 transition-colors">
                  運営者情報
                </Link>
                <Link to="/tokushoho" className="block text-white hover:text-white/80 transition-colors">
                  特定商取引法に基づく表記
                </Link>
                <Link to="/privacy-policy" className="block text-white hover:text-white/80 transition-colors">
                  プライバシーポリシー
                </Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60">© 2025 Trim-Page. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors">
                利用規約
              </a>
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors">
                サイトマップ
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sm text-white/60 hover:text-white transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
